import { pushTrackingData, getTrackingData } from './utils';

const GTM_LOAD_ATTRIBUTE = 'data-gtm-load';

const getTrackableElements = root => [...root.querySelectorAll(`[${GTM_LOAD_ATTRIBUTE}]`)];

const trackLoadedElement = (el) => {
	const trackingData = getTrackingData(el);

	pushTrackingData(trackingData);
};

const startLoadTracking = (root = document.body) => {
	const elements = getTrackableElements(root);

	elements.forEach(trackLoadedElement);
};

export default startLoadTracking;
